import Vimeo from '@vimeo/player';
import { gsap } from 'gsap';

export default class BackgroundHoverVideo {
	constructor(elm) {
		this.hoverElm = elm;

		this.id = this.hoverElm.getAttribute('data-hover-video');
		this.videoContainer = document.querySelector('[data-background]');

		this.wrapper = document.createElement('div');
		this.wrapper.classList.add('c-background__video', 'c-background__video--hover');
		this.wrapper.setAttribute('tabindex', '-1');

		gsap.set(this.wrapper, { opacity: 0 });
		this.videoContainer.appendChild(this.wrapper);

		this.vimeo = new Vimeo(this.wrapper, {
			id: this.id,
			dnt: true,
			autopause: false,

			background: false,
			loop: true,
			autoplay: false,
			controls: false,

			responsive: false,

			muted: true,
			keyboard: false,
			playsinline: true,
			pip: false,

			// Visuals
			byline: false,
			portrait: false,
			speed: false,
			title: false,

			// Performance increase?
			quality: '360p',
		});

		this.hoverElm.addEventListener('mouseenter', () => {
			this.show();
		});
		this.hoverElm.addEventListener('touchstart', () => {
			this.show();
		});
		this.hoverElm.addEventListener('mouseleave', () => {
			this.hide();
		});
		this.hoverElm.addEventListener('touchend', () => {
			this.hide();
		});

	}


	init() {
		return new Promise((resolve, reject) => {
			this.vimeo.ready().then(e => {
				this.vimeo.play();
				resolve();
			}).catch(() => {
				reject();
			});

		});
	}


	show() {
		this.fadeIn();
	}

	hide() {
		this.fadeOut();
	}

	fadeIn() {
		gsap.killTweensOf(this.wrapper);
		gsap.to(this.wrapper, {
			duration: 0.3,
			opacity: 1,
			ease: 'none',
			onBegin: () => {
				this.vimeo.play();
			},
		});
	}

	fadeOut() {
		return new Promise((resolve) => {
			gsap.killTweensOf(this.wrapper);
			gsap.to(this.wrapper, {
				duration: 0.3,
				opacity: 0,
				ease: 'none',
				onComplete: () => {
					resolve();
				},
			});
		});
	}

	destroy() {
		this.fadeOut().then(() => {
			this.wrapper.remove();
		});
	}
}
